var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{attrs:{"min-height":_vm.minHeight,"max-width":_vm.maxWidth,"light":_vm.light,"dark":_vm.dark,"height":_vm.height},on:{"click":(e) => _vm.$emit('click', e)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }